// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "modal-32Wm1";
var _4 = "content-y4h2A";
var _5 = "header-3iy3S";
var _6 = "icon-3m3ci";
var _7 = "text-3ZfPO";
var _8 = "buttons-1ByR_";
var _9 = "button-26SK2";
var _a = "no-175pb";
export { _1 as "__esModule", _2 as "mobile", _3 as "modal", _4 as "content", _5 as "header", _6 as "icon", _7 as "text", _8 as "buttons", _9 as "button", _a as "no" }
export default { "__esModule": _1, "mobile": _2, "modal": _3, "content": _4, "header": _5, "icon": _6, "text": _7, "buttons": _8, "button": _9, "no": _a }
